export const PATHS = {
  HOME: "/",
  OVERVIEW: "/overview",
  SERVICES: "/servizi-diabetologo-bologna",
  CONTACTS: "/contacts",
  EXPERTIES: "/experties",
};
